import { useEffect, useState } from "react";

export const useScrollDirection = () => {
    const [direction, setDirection] = useState(null);
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    useEffect(() => {
        const onScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > lastScrollTop) {
                setDirection("down");
            } else if (scrollTop < lastScrollTop) {
                setDirection("up");
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return direction;
};
